"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _generateUuid = _interopRequireDefault(require("../../../utils/generate-uuid"));

var _Render = _interopRequireDefault(require("./Render"));

var _Form = _interopRequireDefault(require("./Form"));

var _ = require("../../../");

var defaultAttrs = function defaultAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _.Tools.applyDefaults({
    width: "675",
    fontFamily: "'Open Sans', 'Helvetica Neue', 'Helvetica', Arial, sans-serif",
    fontWeight: "500",
    borderSize: 1,
    borderColor: "#a9aaab",
    innerBackgroundColor: "#ffffff",
    paddingTop: 20,
    paddingRight: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    backgroundColor: "#E4E4E4",
    allowChildren: true,
    disableDelete: true,
    footer: null
  }, attrs);
};

var _default = {
  toolbarDisabled: true,
  Render: _Render["default"],
  Form: _Form["default"],
  type: "Wrapper",
  description: "The email wrapper component allows you to safely wrap content in standard email sizes.",
  defaultAttrs: defaultAttrs,
  generateContent: function generateContent() {
    return [{
      id: (0, _generateUuid["default"])(),
      type: "Wrapper",
      content: [],
      attrs: defaultAttrs()
    }];
  }
};
exports["default"] = _default;